import { render, staticRenderFns } from "./HeatmapReport.vue?vue&type=template&id=38654f7a"
import script from "./HeatmapReport.vue?vue&type=script&lang=js"
export * from "./HeatmapReport.vue?vue&type=script&lang=js"
import style0 from "./HeatmapReport.vue?vue&type=style&index=0&id=38654f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports